<template>
  <div class="data-entry">
    <h2>Внесение данных</h2>
    <el-container class="data-entry-content">
      <el-aside :width="asideWidth + 'px'" class="side-panel">
        <org-tree-panel
          ref="orgTree"
          @select="onSelectUnit"
          @scroll-change="asideHasScroll = $event"
        ></org-tree-panel>
      </el-aside>
      <!-- Перетаскиваемая граница левой панели, двойной клик - ширина по умолчанию -->
      <div
        class="side-resizer"
        :class="{ 'has-scroll': asideHasScroll, 'is-dragging': resizing }"
        title="Потяните, чтобы изменить ширину. Двойной клик - исходная ширина"
        @mousedown.prevent="startResize"
        @dblclick="setAsideWidth(DEFAULT_ASIDE_WIDTH)"
      ></div>
      <el-main>
        <entry-wizard
          v-if="selectedUnit && selectedUnit.isWaste"
          ref="entry"
          :key="entryKey"
          :waste="selectedUnit"
          class="wizard"
          @saved="entryKey++"
          @cancel="entryKey++"
        ></entry-wizard>
        <el-empty
          v-else
          description="Раскройте подразделение слева и выберите отход"
        ></el-empty>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import OrgTreePanel from "@/components/ecologist/dataEntryNew/orgTreePanel";
import EntryWizard from "@/components/ecologist/dataEntryNew/entryWizard";

const DEFAULT_ASIDE_WIDTH = 360;
const MIN_ASIDE_WIDTH = 240;
const ASIDE_WIDTH_KEY = "dataEntryNew.asideWidth";

export default {
  name: "dataEntryNewMain",
  components: { OrgTreePanel, EntryWizard },
  data() {
    return {
      selectedUnit: null,
      asideHasScroll: false,
      DEFAULT_ASIDE_WIDTH,
      asideWidth: DEFAULT_ASIDE_WIDTH,
      resizing: false,
      // Смена ключа пересоздаёт мастер: при выборе другого отхода и после сохранения
      entryKey: 0,
    };
  },

  methods: {
    // Не шире 60% экрана внесения данных, чтобы мастеру оставалось место
    setAsideWidth(width) {
      const container = this.$el.querySelector(".data-entry-content");
      const max = Math.max(MIN_ASIDE_WIDTH, container.clientWidth * 0.6);
      this.asideWidth = Math.round(
        Math.min(max, Math.max(MIN_ASIDE_WIDTH, width))
      );
      try {
        localStorage.setItem(ASIDE_WIDTH_KEY, this.asideWidth);
      } catch (e) {
        // ширина просто не запомнится
      }
    },

    startResize(event) {
      const startX = event.clientX;
      const startWidth = this.asideWidth;
      this.resizing = true;
      // Курсор и запрет выделения текста на всей странице, пока тянем
      document.body.classList.add("is-col-resizing");
      const move = (e) => this.setAsideWidth(startWidth + e.clientX - startX);
      const stop = () => {
        this.resizing = false;
        document.body.classList.remove("is-col-resizing");
        window.removeEventListener("mousemove", move);
        window.removeEventListener("mouseup", stop);
      };
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", stop);
    },

    async onSelectUnit(unit) {
      const entry = this.$refs.entry;
      if (entry && entry.isDirty) {
        try {
          await this.confirm(
            "Внимание",
            "Введённые данные не сохранены и будут потеряны. Перейти к другому элементу?",
            "warning",
            "Да",
            "Нет"
          );
        } catch {
          this.$refs.orgTree.setCurrent(
            this.selectedUnit ? this.selectedUnit.key : null
          );
          return;
        }
      }
      this.selectedUnit = unit;
      this.entryKey++;
    },
  },

  mounted() {
    let saved = null;
    try {
      saved = Number(localStorage.getItem(ASIDE_WIDTH_KEY));
    } catch (e) {
      // хранилище недоступно - остаётся ширина по умолчанию
    }
    if (saved) this.setAsideWidth(saved);
  },
};
</script>

<style scoped>
/*
  Корень - обычный блок, а не flex: flex-контейнер сужается плавающей кнопкой «Назад»
  из containerComponent на всю высоту. Заголовок по высоте равен кнопке,
  поэтому контейнер ниже начинается уже после неё и занимает всю ширину.
*/
.data-entry {
  height: var(--content-min-height, 100vh);
}
.data-entry > h2 {
  margin: 0 0 16px;
  line-height: 40px;
}
.data-entry-content {
  height: calc(100% - 56px);
}
.side-panel {
  padding-right: 5px;
}
/* Полоса 7px для захвата мышью, видимая линия - 1.5px по центру */
.side-resizer {
  flex: 0 0 7px;
  margin: 0 -3px;
  position: relative;
  z-index: 1;
  cursor: col-resize;
}
.side-resizer::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 2px;
  /*
    Линия - рамкой, а не фоном: рамку браузер выравнивает по пикселям экрана,
    и при масштабе больше 100% она той же толщины, что и рамки блоков справа
  */
  border-left: 1.5px solid #dcdfe6;
  transition: border-color 0.15s, border-width 0.15s, left 0.15s;
}
/* Когда у дерева есть полоса прокрутки, линию заменяет она */
.side-resizer.has-scroll::before {
  border-left-color: transparent;
}
.side-resizer:hover::before,
.side-resizer.is-dragging::before {
  left: 1px;
  border-left-width: 4px;
  border-left-color: #409eff;
}
.el-main {
  display: flex;
  flex-direction: column;
  padding-top: 0;
  padding-bottom: 0;
  /* Иначе поднятая в строку заголовка линия этапов обрезается; прокрутка - внутри этапа */
  overflow: visible;
  /* Без overflow: auto flex-элемент растягивается под широкую таблицу - запрещаем */
  min-width: 0;
}
.wizard {
  flex: 1;
  min-height: 0;
}
/*
  Линия этапов поднята в строку заголовка: между названием и кнопкой «Назад».
  Линия (56px) по высоте - примерно посередине строки заголовка (40px): сдвиг вверх -
  заголовок с отступом под ним (40 + 16) и ещё 4px на глаз. Справа - место под кнопку
*/
.wizard ::v-deep .step-line {
  margin-top: -60px;
  margin-right: 90px;
  /* Отступ от подписей этапов до календаря и таблицы */
  margin-bottom: 8px;
}
</style>

<style>
body.is-col-resizing {
  cursor: col-resize;
  user-select: none;
}
</style>
